// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__219vA","checkboxCol":"Table_checkboxCol__1lwz6","emailCol":"Table_emailCol__3eYa_","actionCol":"Table_actionCol__36QrN"};